import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useShop } from "../lib/shop";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState({ loading: true, ok: false, message: "" });
    const { refreshUser } = useShop();

    useEffect(() => {
        if (!token) {
            setState({ loading: false, ok: false, message: "This verification link is missing its token." });
            return;
        }
        api.get(`/auth/verify-email?token=${token}`)
            .then(async (r) => {
                setState({ loading: false, ok: true, message: r.data.message });
                await refreshUser();
            })
            .catch((err) =>
                setState({ loading: false, ok: false, message: formatApiError(err.response?.data?.detail, "Verification failed") })
            );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <main className="min-h-[60vh] bg-slate-50 flex items-center justify-center px-4" data-testid="verify-page">
            <div className="bg-white rounded-2xl border border-slate-200 p-10 max-w-md w-full text-center">
                {state.loading ? (
                    <>
                        <Loader2 className="h-12 w-12 text-[#0033A0] mx-auto mb-4 animate-spin" />
                        <p className="text-slate-500">Verifying your email…</p>
                    </>
                ) : state.ok ? (
                    <>
                        <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto mb-4" />
                        <h1 className="font-heading text-2xl font-extrabold text-slate-900 mb-2" data-testid="verify-success">Email verified!</h1>
                        <p className="text-slate-500 text-sm mb-6">{state.message}</p>
                        <Link to="/account" data-testid="verify-account-link"
                            className="inline-block rounded-full bg-[#0033A0] px-8 py-3 font-heading font-bold text-white hover:bg-[#002277]">
                            Go to My Account
                        </Link>
                    </>
                ) : (
                    <>
                        <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
                        <h1 className="font-heading text-2xl font-extrabold text-slate-900 mb-2" data-testid="verify-failed">Link not valid</h1>
                        <p className="text-slate-500 text-sm mb-6">{state.message}</p>
                        <Link to="/account" data-testid="verify-account-link-alt" className="text-[#0033A0] font-bold hover:underline text-sm">
                            Go to your account to request a new link
                        </Link>
                    </>
                )}
            </div>
        </main>
    );
}
